<template>
  <div class="edsi-Wrapper">
    <ElementDataSourceIcon :type-id="dataSourceQuery.dataSourceTypeId" />
    <i18n-t
      keypath="data_source.sync_message.check_in"
      tag="div"
      class="edsi-Message"
      scope="global"
    >
      <template #dataSourceName>
        <span class="edsi-Message_DataSourceName">{{ dataSourceQuery.dataSourceQueryName }}</span>
      </template>
    </i18n-t>
  </div>
</template>

<script setup>
import ElementDataSourceIcon from '@/components/form/ElementDataSourceIcon'

defineOptions({
  name: 'ElementDataSourceInfo'
})

defineProps({
  dataSourceQuery: {
    type: Object,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.edsi-Wrapper {
  display: flex;
  gap: 8px;
}

.edsi-Message {
  color: $dark-3;
  text-overflow: ellipsis;
  font-size: $fs-14;
  font-weight: fw('regular');
  line-height: 20px;
  word-break: break-all;
}

.edsi-Message_DataSourceName {
  font-weight: fw('bold');
}
</style>
